import { onUnmounted, type Ref } from 'vue'
import { onListChanged } from '@/composables/useConversationRealtime'
import { getConversation, type ConversationDetail } from '@/services/wootdashConversations'

// Etiqueta da versão do bot (BotVersionTag) na janela de chat: com o bot atendendo, cada mudança da conversa aberta
// (o bot respondeu, transferiu, encerrou) pede de novo só a parte do bot — sem polling. 1 s de espera junta vários
// avisos do mesmo turno num pedido só.
export function useBotVersionRefresh(conversation: Ref<ConversationDetail | null>, token: () => string): void {
  let timer: ReturnType<typeof setTimeout> | null = null

  const off = onListChanged(item => {
    const conv = conversation.value
    if (!conv || item.id !== conv.id || conv.bot?.status !== 'running') return
    if (timer) clearTimeout(timer)
    timer = setTimeout(async () => {
      timer = null
      const fresh = await getConversation(token(), item.id).catch(() => null)
      const current = conversation.value
      if (fresh && current?.id === fresh.id) conversation.value = { ...current, bot: fresh.bot ?? null }
    }, 1_000)
  })

  onUnmounted(() => {
    if (timer) clearTimeout(timer)
    off()
  })
}
